import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import StopIcon from "@mui/icons-material/Stop";
import CircularProgress from "@mui/material/CircularProgress";

import { useTextToSpeech } from "../../hooks/useTextToSpeech.ts";

interface TextToSpeechProps {
  text: string;
  exchange_id: string | undefined;
}

const TextToSpeechButton: React.FC<TextToSpeechProps> = ({
  exchange_id: exchangeID,
  text,
}) => {
  const { speak, stop, state } = useTextToSpeech();

  const handleOnClick = () => {
    if (state === "playing" || state === "loading") {
      stop();
    } else {
      void speak(exchangeID, text);
    }
  };

  return (
    <Box>
      <Tooltip
        title={state === "playing" ? "Stop" : "Listen"}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "0.9rem",
            },
          },
        }}
      >
        <span>
          <IconButton onClick={handleOnClick} size="small">
            {state === "loading" && <CircularProgress size={20} />}
            {state === "playing" && <StopIcon fontSize="small" />}
            {state === "idle" && <VolumeUpIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default TextToSpeechButton;
